import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1665c741"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "projects-list" }
const _hoisted_2 = { class: "projects-list__actions" }

import { computed, ref } from 'vue';
import type { QTableProps } from 'quasar';

import formatDate from '@/hooks/formatDate';
import ProjectInterface from '@/interfaces/Project.interface';
import ProjectsForm from './CreateEditProjectModal.vue';
import DeleteProjectModal from './DeleteProjectModal.vue';

import DSPageHeader from '@/design-system/DSPageHeader.vue';
import DSTable from '@/design-system/DSTable.vue';
import DSButton from '@/design-system/DSButton.vue';

import { useStore } from '@/store';
import { FETCH_PROJECTS } from '@/store/types/actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsList',
  setup(__props) {

const projectsForm = ref(ProjectsForm);
const deleteProjectModal = ref(DeleteProjectModal);

const store = useStore();
store.dispatch(FETCH_PROJECTS);

const projects = computed(() => store.state.project.projects);

const columns: QTableProps['columns'] = [
  {
    name: 'Name',
    field: 'name',
    label: 'Name',
    align: 'left',
    sortable: true,
  },
  {
    name: 'createdAt',
    field: (row) => formatDate(new Date(row.createdAt)),
    label: 'Created at',
    align: 'left',
    sortable: true,
    style: 'width: 180px',
  },
  {
    name: 'actions',
    field: 'id',
    label: '',
    align: 'right',
    style: 'width: 160px',
  },
];

const handleEditProject = (project: ProjectInterface) => {
  projectsForm.value.showModal(project);
  projectsForm.value.project = project;
};

const handleDeleteProject = (project: ProjectInterface) => {
  deleteProjectModal.value.showModal(project);
};

const handleCreateProject = () => {
  projectsForm.value.showModal();
};

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DSPageHeader, { title: "Projects" }, {
      right: _withCtx(() => [
        _createVNode(DSButton, {
          icon: "add",
          label: "New Project",
          onClick: handleCreateProject
        })
      ]),
      _: 1
    }),
    _createVNode(DSTable, {
      rows: projects.value,
      columns: columns,
      loading: false,
      dense: "",
      "sticky-header": "",
      class: "projects-list__table"
    }, {
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(DSButton, {
                icon: "edit",
                variant: "secondary",
                size: "sm",
                class: "projects-list__action-btn",
                onClick: ($event: any) => (handleEditProject(props.row)),
                "aria-label": "Edit project"
              }, null, 8, ["onClick"]),
              _createVNode(DSButton, {
                icon: "delete",
                variant: "danger",
                size: "sm",
                class: "projects-list__action-btn",
                onClick: ($event: any) => (handleDeleteProject(props.row)),
                "aria-label": "Delete project"
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["rows"]),
    _createVNode(ProjectsForm, {
      ref_key: "projectsForm",
      ref: projectsForm
    }, null, 512),
    _createVNode(DeleteProjectModal, {
      ref_key: "deleteProjectModal",
      ref: deleteProjectModal
    }, null, 512)
  ]))
}
}

})